import React from 'react'
import { Button } from '@mui/material'
import { useCanDownloadReport } from '@/hooks'
import { t } from '@/i18n'
import PopupMenu from '../PopupMenu'
import { getMenuSections } from './AdditionalFunctionsMenu'
import { useAdditionalFunctionsHandlers } from './AdditionalFunctionsHandlers'
import CarLicenseUploadModal from '../modals/CarLicenseUploadModal'
import DealInvoicesExportModal from '../modals/DealInvoicesExportModal'

const AdditionalFunctions: React.FC = () => {
  const canDownloadReport = useCanDownloadReport()
  const {
    downloading,
    handling,
    menuAnchorEl,
    isDealInvoicesExportOpen,
    isCarLicenseUploadOpen,
    handleMenuClick,
    handleMenuClose,
    handleMenuItemClick,
    closeDealInvoicesExport,
    closeCarLicenseUpload,
  } = useAdditionalFunctionsHandlers()

  if (!canDownloadReport) return null

  return (
    <>
      <Button
        onClick={handleMenuClick}
        startIcon={<span className="icon-upload" />}
        disabled={downloading || handling}
        sx={{
          '& .MuiButton-startIcon': {
            marginLeft: '8px',
          },
        }}
      >
        {t('additional_functions')}
      </Button>
      <PopupMenu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        sections={getMenuSections()}
        onItemClick={handleMenuItemClick}
        disabled={downloading || handling}
      />
      {isDealInvoicesExportOpen && (
        <DealInvoicesExportModal
          isOpen={isDealInvoicesExportOpen}
          onClose={() => {
            closeDealInvoicesExport()
            handleMenuClose()
          }}
        />
      )}
      {isCarLicenseUploadOpen && (
        <CarLicenseUploadModal
          isOpen={isCarLicenseUploadOpen}
          onClose={() => {
            closeCarLicenseUpload()
            handleMenuClose()
          }}
        />
      )}
    </>
  )
}

export default AdditionalFunctions 